import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Wizard } from 'react-use-wizard';
import { hideModal } from '../../../redux/actions/modal';
import text from '../../../text';
export var MANUAL_ORDER_MODAL = 'MANUAL_ORDER_MODAL';
var ManualOrderModal = function(props) {
    var show = props.show;
    var dispatch = useDispatch();
    var history = useHistory();
    var handleHide = function() {
        return dispatch(hideModal(MANUAL_ORDER_MODAL));
    };
    var handleCancel = function() {
        handleHide();
    };
    var handleReturn = function() {
        handleCancel();
        history.push('/');
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: handleHide
    }, /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement(Wizard, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", {
        className: "metromap-modal-heading text-center w-100"
    }, text('thanksForYourOrder')), /*#__PURE__*/ React.createElement("div", {
        className: "text-center text-grey-1"
    }, text('orderSubmitSucces')), /*#__PURE__*/ React.createElement("div", {
        className: "text-center text-grey-1 software-success-body"
    }, text('salesPersonWillContactYou')), /*#__PURE__*/ React.createElement("div", {
        className: "form-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleReturn
    }, text('goToDashboard')))))));
};
export default ManualOrderModal;
